import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SetIsShowLoginDialog } from '../../../Interface'
import './index.scss'
import SlickSlider from 'react-slick'

import { Trans } from 'react-i18next'
import i18n from '../../../i18n'

class MainSection extends Component {

    slickRef
    slickChangeTime = Date.now()

    interval
    slickAnimationInterval = () => {
        if (this.slickRef) {
            const now = Date.now()
            if (now - this.slickChangeTime >= 1000 && this.slickRef) {
                this.slickRef.slickNext()
                this.slickChangeTime = now
            }
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.interval = setInterval(this.slickAnimationInterval, 100)
        }, 1000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    renderVideo = () => {
        const { lang } = this.props

        let src = ''
        switch (lang) {
            case 'ko':
                src = 'https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/ko_landing.mp4'
                break

            case 'en':
                src = 'https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/en_landing.mp4'
                break

            default:
                src = 'https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/en_landing.mp4'
                break
        }

        return <video autoPlay loop muted src={src} />
    }

    render() {
        const { lang: orgLang, currentUser } = this.props

        // TO DO : i18n 국제화
        const keywords = [
            '마케팅',
            '이벤트',
            '쇼핑몰',
            '부동산',
            '상 품',
            '기 업',
            '병 원',
            'SNS',
        ]

        const slickSetting = {
            infinite: true,
            slidesToShow: 1,
            vertical: true,
            verticalSwiping: true
        }

        return (
            <div className={`main-section-root-container`}>
                <div className='main-section-body'>
                    {
                        orgLang === 'ko'
                            ?
                            <div className={`left-area ${orgLang}`}>
                                <div className='left-title-area'>
                                    <div className='title main'>{i18n.t("web.newhome.main.section.title1")}</div>
                                    <div className='title-area'>
                                        <div className='slick-wrapper'>
                                            <SlickSlider
                                                {...slickSetting}
                                                ref={ref => this.slickRef = ref}
                                            >
                                                {
                                                    keywords.map(item => (
                                                        <div className='slick-item'>
                                                            {item}
                                                        </div>
                                                    ))
                                                }
                                            </SlickSlider>
                                        </div>

                                        <div className='title sub'>{i18n.t("web.newhome.main.section.title2")}</div>
                                    </div>
                                    <div className='subtitle'>Videomonster</div>
                                </div>
                                <div className={`setting-btn ${orgLang}`} onClick={() => {
                                    if (currentUser) this.props.history.push('/designselect')
                                    else SetIsShowLoginDialog(true)
                                }}>
                                    {i18n.t("web.newhome.main.section.freebtn")}
                                </div>
                            </div>
                            :
                            <div className={`left-area-en ${orgLang}`}>
                                <div className='left-title-area'>
                                    <div className='title'>{i18n.t("web.newhome.main.section.en.title")}</div>
                                    <div className='subtitle'>{i18n.t("web.newhome.main.section.en.subtitle")}</div>
                                    <div className='des'>
                                        <Trans i18nKey="web.newhome.main.section.en.des">
                                            <br />
                                        </Trans>
                                    </div>
                                </div>
                                <div className={`setting-btn ${orgLang}`} onClick={() => {
                                    if (currentUser) this.props.history.push('/designselect')
                                    else SetIsShowLoginDialog(true)
                                }}>
                                    {i18n.t("web.newhome.main.section.en.button")}
                                </div>
                            </div>
                    }
                    <div className='right-area'>
                        <div className='main-section-video-area'>
                            <div className='shadow' />
                            <img src='https://front.videomonster.com/images-u6yd72dy/web/home/main-section-icon.svg' alt='' />
                            {this.renderVideo()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(MainSection)